import styled from 'styled-components';

export const DashboardWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 64px);
  background: ${({ theme }) => theme.landing.background};
  transition: background 0.3s ease;
`;

export const DashboardContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  margin-top: 64px;
  padding: ${({ theme }) => theme.landingSpacing.xl};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    padding: ${({ theme }) => theme.landingSpacing.lg};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.landingSpacing.xl};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.landingSpacing.md};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SectionTitle = styled.h1`
  font-weight: 500;
  font-size: 1.75rem;
  line-height: 1.2;
  margin: 0;
  color: ${({ theme }) => theme.landing.text};
  letter-spacing: -0.025em;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    font-size: 1.75rem;
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 1.5rem;
  }
`;

export const SectionDescription = styled.p`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.landing.textSecondary};
  margin: 4px 0 0 0;
  padding: 0;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 0.95rem;
  }
`;

export const NewApplicationButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  background: ${({ theme }) => theme.landing.buttonBg};
  color: #fff;
  border: none;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
  font-size: 1rem;
  line-height: 1.3;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    background: ${({ theme }) => theme.landing.buttonHover};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    width: 100%;
    justify-content: center;
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    width: 100%;
    padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
    font-size: 0.95rem;
  }
`;

export const ApplicationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: ${({ theme }) => theme.landingSpacing.lg};
  margin-bottom: ${({ theme }) => theme.landingSpacing.xl};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: ${({ theme }) => theme.landingSpacing.md};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    grid-template-columns: repeat(2, 1fr);
    gap: ${({ theme }) => theme.landingSpacing.md};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const ApplicationCard = styled.div`
  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: ${({ theme }) => theme.landingSpacing.lg};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.md};
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.landing.buttonBg};
    box-shadow: 0px 8px 24px rgba(37, 99, 235, 0.1);
    transform: translateY(-4px);
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const ApplicationIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const ApplicationHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.xs};
`;

export const ApplicationTitle = styled.h3`
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.4;
  margin: 0;
  color: ${({ theme }) => theme.landing.text};
  transition: color 0.2s ease;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 1rem;
  }
`;

export const ApplicationMeta = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.xs};
  font-weight: 400;
  font-size: 0.85rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.textSecondary};

  span {
    &:nth-child(2) {
      color: ${({ theme }) => theme.landing.textSecondary};
    }
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 0.8rem;
  }
`;

export const ApplicationActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.landingSpacing.xs};
  padding-top: ${({ theme }) => theme.landingSpacing.md};
  border-top: 1px solid ${({ theme }) => theme.landing.cardBorder};
`;

export const ViewButton = styled.button`
  background: transparent;
  color: ${({ theme }) => theme.landing.text};
  border: none;
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: ${({ theme }) => theme.landingSpacing.xs} ${({ theme }) => theme.landingSpacing.sm};
  font-weight: 500;
  font-size: 0.95rem;
  line-height: 1.4;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 0.9rem;
    padding: ${({ theme }) => theme.landingSpacing.xs} ${({ theme }) => theme.landingSpacing.xs};
  }
`;

export const PaginationSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.landingSpacing.md};
  padding: ${({ theme }) => theme.landingSpacing.lg};
  margin-top: ${({ theme }) => theme.landingSpacing.xl};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const PaginationButton = styled.button`
  background: ${({ theme }) => theme.landing.cardBg};
  color: ${({ theme }) => theme.landing.text};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};

  font-size: 0.95rem;
  line-height: 1.4;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.landing.buttonBg};
    color: ${({ theme }) => theme.landing.text};
    border-color: ${({ theme }) => theme.landing.buttonBg};
    transform: translateY(-2px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.xs} ${({ theme }) => theme.landingSpacing.md};
    font-size: 0.9rem;
  }
`;

export const PaginationInfo = styled.span`
  font-weight: 500;
  font-size: 0.95rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.textSecondary};
  min-width: 40px;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 0.9rem;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.landingSpacing.xl};
  text-align: center;

  p {
    font-weight: 500;
    font-size: 1.125rem;
    line-height: 1.5;
    color: ${({ theme }) => theme.landing.text};
    margin: 0;

    &:last-child {
      font-weight: 400;
      font-size: 1rem;
      color: ${({ theme }) => theme.landing.textSecondary};
      margin-top: ${({ theme }) => theme.landingSpacing.xs};
    }
  }
`;

export const DeleteIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fdf0ee;
  color: #d84c42;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
  }
`;
